<template>
  <div class="organism sidebar-testimonials">
    <MoleculesSidebarSubscribe>
      <template #title>Subscribe to Our Reviews</template>
      <template #default>
        Get notified the next time an authentic review from a Boulder Creek
        homebuyer is posted.
      </template>
    </MoleculesSidebarSubscribe>
    <MoleculesSidebarCategories :molecule="categoriesMolecule" />
    <MoleculesSidebarPopularPosts :molecule="popularPostsMolecule" />
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
const testimonials = useTestimonials();
const { testimonialCategories, popularTestimonials } =
  storeToRefs(testimonials);

const props = defineProps({
  organism: Object,
});

const categoriesMolecule = computed(() => {
  return {
    categories: testimonialCategories?.value.map((category) => {
      return {
        title: category.name,
        slug: category.slug,
        uri: "/lifestyle/reviews/category/" + category.slug,
        count: category.count,
      };
    }),
  };
});

const popularPostsMolecule = ref([]);

const updatePopularPostsMolecule = (popularPosts) => {
  return {
    posts: popularPosts.map((post) => {
      return {
        title: post?.title,
        category: post?.testimonialCategories?.nodes?.[0]?.name ?? "",
        uri: "/lifestyle/reviews/" + post?.slug,
        image: post?.customPostDetails?.thumbnail,
      };
    }),
  };
};

watch(
  popularTestimonials,
  (newValue, oldValue) => {
    if (newValue !== oldValue && import.meta.client) {
      popularPostsMolecule.value = updatePopularPostsMolecule(newValue);
    }
  },
  { deep: true, immediate: true },
);
</script>
